import { AppliedStatus } from '@hooks-api/types/dataModel/coupon'
import { parseCouponEndTime } from '../parser/parseCouponEndTime'
import { type MergedCoupon } from '../types'

const couponsEndTimeCompare = (a: MergedCoupon, b: MergedCoupon) => parseCouponEndTime(a.end_time) - parseCouponEndTime(b.end_time)

/**
 * 1. 可抵用放上面
 * 2. 使用期限近的放上面，無期限放最下面
 */
export const sortCoupons = (coupons: MergedCoupon[]) => {
  const appliedCoupons: MergedCoupon[] = []
  const unappliedCoupons: MergedCoupon[] = []
  coupons.forEach((coupon) => {
    const isApplied = coupon.criterions.some(criterion => criterion.applied_status === AppliedStatus.APPLIED)
    if (isApplied) {
      appliedCoupons.push(coupon)
    }
    else {
      unappliedCoupons.push(coupon)
    }
  })
  return [
    ...appliedCoupons.sort(couponsEndTimeCompare),
    ...unappliedCoupons.sort(couponsEndTimeCompare),
  ]
}
